import { AuthenticationRequest, AuthenticationResponse, RegistrationRequest, RegistrationResponse } from '@velorum/browser-authenticator';

export enum Bank {
    ASN = 'asn',
    BLG = 'blg',
    RGB = 'rgb',
    SNS = 'sns'
}

export type FidoAuthenticationRequest = AuthenticationRequest;

export type FidoAuthenticationResponse = AuthenticationResponse;

export interface FidoUafRegistrationRequest extends RegistrationRequest {
    username?: string;
}

export type FidoUafRegistrationResponse = RegistrationResponse;

export interface DeviceRegistration {
    id?: string;
    type: DeviceRegistrationType;
    status?: DeviceRegistrationStatus;
    bank?: Bank;
}

export type MobileAppRegistration = DeviceRegistration;

export interface BrowserRegistration extends DeviceRegistration {
    os_family: string; // Windows
    browser_family: string; // Chrome
    alias: string; // Living room PC
}

export interface DeviceRegistrationPatch {
    status: DeviceRegistrationStatus;
}

export interface SessionBindingInfo {
    challenge: string;
    is_bound: boolean;
}

export interface SessionBindingPatch {
    is_bound: boolean;
}

export interface AuthenticationRequestOtpMessage {
    authentication_task_id: string;
    key_id: string;
    challenge: string;
    aaid: string;
}

export interface AuthenticatorMetadata {
    validationGroup: string;
    sessionAuthenticated: boolean;
}

export interface PhoneNumberMetadata {
    available: boolean;
    maskedPhoneNumber: string;
    communicationType: CommunicationType;
}

export enum DeviceRegistrationStatus {
    PENDING = 'pending',
    REGISTERED = 'registered'
}

export enum DeviceRegistrationType {
    MOBILE_APP = 'mobile_app',
    BROWSER = 'browser'
}

// see https://bitbucket.verz.local:8443/projects/LSM-J2/repos/session-manager/browse/src/main/java/nl/devolksbank/lsm/authentication/fido/constant/ErrorCode.java
export enum ErrorCode {
    TASK_NOT_YOURS = 'task_not_yours',
    NO_AVAILABLE_TOKENS = 'no_available_tokens',
    NOT_AUTHORIZED = 'not_authorized',
    INVALID_CREDENTIALS = 'invalid_credentials',
    TOKEN_BLOCKED_AT_NEXT_FAILED_SIGNING = 'token_blocked_at_next_failed_signing',
    TOKEN_BLOCKED = 'token_blocked',
    TOKEN_BLOCKED_PERMANENTLY_AT_NEXT_FAILED_SIGNING = 'token_blocked_permanently_at_next_failed_signing',
    TOKEN_BLOCKED_PERMANENTLY = 'token_blocked_permanently',
    TOKEN_NOT_ACTIVE = 'token_not_active',
    ASSERTION_DOES_NOT_MATCH_POLICY = 'assertion_does_not_match_policy',
    TASK_EXPIRED = 'task_expired',
    MUST_CHANGE_CREDENTIALS = 'must_change_credentials',
    MUST_CHANGE_PASSWORD = 'must_change_password',
    STRONG_TOKEN_REQUIRED = 'strong_token_required',
    AUTHENTICATION_REQUEST_SUPERSEDED = 'authentication_request_superseded'
}

// see https://bitbucket.verz.local:8443/projects/LSM-J2/repos/session-manager/browse/src/main/java/nl/devolksbank/lsm/models/TokenTypeId.java#11
export enum TokenTypeId {
    DIGIPAS = 'DVBK#DGPS',
    DIGICODE = 'DVBK#DGCD',
    PROSPECT_DIGICODE = 'DVBK#DGCL',

    MOBILE_DEVICE = 'DVBK#MDEV',
    MOBILE_PINCODE = 'DVBK#MPIN',
    MOBILE_FINGERPRINT = 'DVBK#MFIN',
    MOBILE_FACE = 'DVBK#MFAC',
    MOBILE_BIOMETRIC = 'DVBK#MBIO',

    MOBILE_DEVICE_HIGH = 'DVBK#DEVH',
    MOBILE_DEVICE_LOW = 'DVBK#DEVL',
    MOBILE_PINCODE_HIGH = 'DVBK#MPCH',
    MOBILE_PINCODE_LOW = 'DVBK#MPCL',
    MOBILE_FINGERPRINT_HIGH = 'DVBK#FIPH',
    MOBILE_FINGERPRINT_LOW = 'DVBK#FIPL',
    MOBILE_FACE_HIGH = 'DVBK#FACH',
    MOBILE_FACE_LOW = 'DVBK#FACL',
    MOBILE_BIOMETRIC_HIGH = 'DVBK#BIOH',
    MOBILE_BIOMETRIC_LOW = 'DVBK#BIOL',

    BROWSER_DEVICE = 'DVBK#BRDV',
    BROWSER_PINCODE = 'DVBK#BRPC',
    PHONE_NUMBER = 'DVBK#PHNR'
}

export enum ContentTypeId {
    TEXT_PLAIN = 'text/plain',
    APPLICATION_JSON = 'application/json',
    DVB_DIGIPASACTION = 'x-devolksbank/digipasAction',
    VND_DEVOLKSBANK_AUTHREQUEST_JSON = 'application/vnd.devolksbank.authrequest+json',
    VND_DEVOLKSBANK_AUTHREQUEST_SPENDING_JSON = 'application/vnd.devolksbank.authrequest.spending+json'
}

export enum ExtensionId {
    AUTHENTICATOR_METADATA = 'nl.devolksbank.fido.uaf.authenticator.metadata',
    PHONE_NUMBER_METADATA = 'nl.devolksbank.fido.uaf.token.phone.number.metadata'
}

export enum CommunicationType {
    TEXT = 'text',
    VOICE = 'voice'
}
